






















































import Modal from "../core/Modals/Modal.vue";
import DateInput from "../core/Forms/DateInput.vue";
import moment from "moment";

export default {
    name: "ClientArchiveModal",
    components: {
        Modal,
        DateInput,
    },
    props: {
        showModal: Boolean,
        clientName: String,
        client: Object,
    },
    data() {
        return {
            endDate: "",
            setEndDate: false,
        };
    },
    created() {
        // Initialize with empty date - user can choose to set one
        this.endDate = "";
        this.setEndDate = false;
    },
    methods: {
        closeModal() {
            this.$emit("close-modal");
        },
        confirmArchive() {
            this.$emit("confirm-archive", {
                client: this.client,
                endDate: this.setEndDate ? this.endDate : null,
            });
        },
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                // Reset modal state when it opens
                this.setEndDate = false;
                this.endDate = "";
            }
        },
        setEndDate(newVal) {
            if (newVal) {
                // Set default date to today when checkbox is checked
                this.endDate = moment().format("DD/MM/YYYY");
            } else {
                // Clear date when checkbox is unchecked
                this.endDate = "";
            }
        },
    },
};
